import { render, staticRenderFns } from "./HeaderCollege.vue?vue&type=template&id=a0ca77c6&"
import script from "./HeaderCollege.vue?vue&type=script&lang=js&"
export * from "./HeaderCollege.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCollege.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports